import { storeConstants } from '@utils/constants';
import factory from '@helpers/storeFactories/factory';

import apiService from './apiService';
import normalize from './normalize';

const STORE_NAME = 'reconciliationDynamic';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiService.get,
    },
    {
        actions: {
            delete: true,
            select: true,
        },
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 99,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalize,
    },
    {
        getters: {
            isMultiSelected: (state, getters) => () => {
                return getters.getAllSelected().length > 1;
            },
        },
    }
);

export default store;
